import React from 'react';
import ellipse from '../../style/images/Group-5.png';
import {connect} from 'trim-redux';
import {AddComma} from "../../utils";

const BalanceStatus = ({name , lastName ,userMonthCredit , userRemainMonthCredit
                           , maxRecepCredit , maxRemainCredit , sponsorName , nationalCode}) => {
                            const userSponsorID =  JSON.parse(localStorage?.userSponsor) && JSON.parse(localStorage?.userSponsor) === 111111155 || JSON.parse(localStorage?.userSponsor) === 111111157;
    return(
        <div>
            <div className='balance-status-section'>
                <div className='balance-status-wrapper'>
                    <div className='balance-status'>
                        <section>
                            <span className='balance-status-title'>:صاحب اعتبار</span>
                        </section>
                        <section className='balance-status-aligns'>
                            <span className='balance-status-txt'>{localStorage.name} {localStorage.lastName}</span>
                        </section>
                    </div>
                    {/*<div className='balance-status'>*/}
                        {/*<section>*/}
                            {/*<span className='balance-status-title'>:کد ملی</span>*/}
                        {/*</section>*/}
                        {/*<section className='balance-status-aligns'>*/}
                            {/*<span className='balance-status-txt'>nationalCode</span>*/}
                            {/**/}
                        {/*</section>*/}
                    {/*</div>*/}

                    {
                        !userSponsorID && 
                        <div className='balance-status'>
                        <section>
                            <span className='balance-status-title'>:مرجع  اعتبار دهنده</span>
                        </section>
                        <section className='balance-status-aligns'>
                            <span className='balance-status-txt'>{localStorage.sponsorName}</span>
                           
                        </section>
                    </div>
                    }
                   
                </div>
                {/*<div className='balance-status'>*/}
                    {/*<section>*/}
                        {/*<span className='balance-status-title'>:اعتبار ماهانه شما</span>*/}
                    {/*</section>*/}
                    {/*<section className='balance-status-aligns'>*/}
                        {/*<span className='balance-status-txt'>{AddComma(localStorage.userMonthCredit)}</span>*/}
                        {/*<span className='balance-status-rial'>ریال</span>*/}
                    {/*</section>*/}
                {/*</div>*/}
                {/*<div className='balance-status'>*/}
                    {/*<section>*/}
                        {/*<span className='balance-status-title'>:سقف اعتبار</span>*/}
                    {/*</section>*/}
                    {/*<section className='balance-status-aligns'>*/}
                        {/*<span className='balance-status-txt'>{AddComma(localStorage.maxCredit)}</span>*/}
                        {/*<span className='balance-status-rial' >ریال</span>*/}
                    {/*</section>*/}
                {/*</div>*/}
{
     !userSponsorID && 
     <div className='balance-status-remain-wrapper'>
                    <div className='balance-status'>
                        <section>
                            <span className='balance-status-title'>:اعتبار ماهانه باقیمانده </span>
                        </section>
                        <section className='balance-status-aligns'>
                            <span className='balance-status-txt'>{AddComma(localStorage.userRemainMonthCredit)}</span>
                            <span className='balance-status-rial'>ریال</span>
                        </section>
                    </div>
                    <div className='balance-status'>
                        <section>
                            <p className='balance-status-title' style={{textAlign: 'right'}}>:سقف اعتبار قابل مصرف در این پذیرنده</p>
                        </section>
                        <section className='balance-status-aligns'>
                            <span className='balance-status-txt'>{AddComma(JSON.parse(localStorage.debts).pop() * Number(localStorage.userRemainMonthCredit))}</span>
                            <span className='balance-status-rial' >ریال</span>
                        </section>
                    </div>
                </div>
             
}

                
            </div>
            
        </div>
    )
};
const mstp = state => ({
    name: state.name,
    lastName: state.lastName,
    userMonthCredit: state.userMonthCredit,
    userRemainMonthCredit: state.userRemainMonthCredit,
    maxRecepCredit: state.maxRecepCredit,
    // userRemainMonthCredit: state.userRemainMonthCredit,
    maxRemainCredit: state.maxRemainCredit,
    nationalCode: state.nationalCode
});
export default connect (mstp)(BalanceStatus);